import $ from 'jquery';

/*
 * Bootstrap Media Query
 *
 * Emits a `Bootstrap-MediaQuery` event after viewport
 * has changed size.
 *
 */

class BootstrapMediaQuery {

    /**
     *
     */
    constructor(window) {
        this.previous = null;
        this.current = null;

        const $window = $(window);
        $window.on('resize', () => {
            const previous = this.current;
            const next = BootstrapMediaQuery.calculate($window);

            if (previous === next) {
                return;
            }

            this.current = next;
            this.previous = previous;

            $window.trigger(
                jQuery.Event('Bootstrap-MediaQuery', this)
            );
        });
    }

    /**
     *
     */
    getPrevious() {
        return this.previous;
    }

    /**
     *
     */
    getSize(force = false) {
        if (this.currentSize && !force) {
            return this.currentSize;
        }
    }

    /**
     *
     */
    static calculate($window) {
        const width = $window.width();

        if (width >= 1200) {
            return 'lg';
        } else if (width >= 992) {
            return 'md';
        } else if (width >= 768) {
            return 'sm';
        }

        return 'xs';
    }
}

export default new BootstrapMediaQuery(window);
